<template>
    <a-layout>
      <a-layout-header >  
        <headerHeader></headerHeader>
      </a-layout-header>
      <a-layout-content>
        <siderHome></siderHome>
      </a-layout-content>
      <a-layout-footer>
        <footerHome></footerHome>
      </a-layout-footer>
    </a-layout>

</template>
<script>
import headerHeader from "@/components/home/headerHeader"
import siderHome from "@/components/home/siderHome"
import footerHome from "@/components/home/footerHome"
export default {
  name: 'index',
  components: {
    headerHeader,
    siderHome,
    footerHome
  },
  data () {
    return {
      msg: 'index'
    }
  },
  mounted(){

  }
}
</script>
<style scoped lang="less">

</style>